import { ActivityDefinitionDocument, APIQueryParamFragments, APIResponse, CRMActivityDefinitionAPIPathGenerator } from "server-model";
import { CRMActivityDefinitionConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerCRMActivityDefinitionConnector extends AppServerConnector implements CRMActivityDefinitionConnector {
    async getActivityDefinition(activityName: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMActivityDefinitionAPIPathGenerator.details(activityName),
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Activity definition not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async listActivityDefinition(organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMActivityDefinitionAPIPathGenerator.list(),
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Activity definitions not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async createActivityDefinition(activityDefinitionDocument: ActivityDefinitionDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMActivityDefinitionAPIPathGenerator.create(),
                { activityDefinitionDocument: this.toPlain(activityDefinitionDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create activity definition")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async updateActivityDefinition(activityName: string, organisationId: string, activityDefinitionDocument: ActivityDefinitionDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                CRMActivityDefinitionAPIPathGenerator.update(activityName),
                { activityDefinitionDocument: this.toPlain(activityDefinitionDocument) },
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update activity definition")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async deleteActivityDefinition(activityName: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                CRMActivityDefinitionAPIPathGenerator.delete(activityName),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete activity definition")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}